import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';

const Tab1 = ({ ItemGroupName, ParentItemGroup, UnicommerceProductCategoryCode, IsGroup }) => {

  return (
       <div>
      <div className="px-4 py-4" style={{ background: 'white' }}>

        <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>

              <div style={{ display: 'flex', gap: '15px', marginBottom: '-10px' }}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600', marginLeft: '2px' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                   <Input
            id="ItemGroupName"
            label="Item Group Name"
            style={{ height: "30px",border: ItemGroupName.Error ? "1px solid red" : "", }}
            value={ItemGroupName.ItemGroupName}
            readOnly
          />
                </div>
                  <div style={{ flex: 1 }}>
                      <Input
            id="ParentItemGroup"
            style={{
              height: "30px",
              border: ParentItemGroup.Error ? "1px solid red" : "",
            }}
            label="Parent Item Group"
            value={ParentItemGroup.select_ParentItemGroup}
            readOnly
          />
                  
                </div>
               
                <div style={{ flex: 1 }}>
                  <label style={{height: '19px'}}></label>
                  <Checkbox
            id="IsGroup"
            label="Is Group"
            value={IsGroup?.IsGroup || false}
         disabled={true}
          />
<div style={{ fontSize: "9px", color: "#00000099", marginLeft:'23px' }}>
    Only leaf nodes are allowed in transaction
  </div>
                </div>
                 <div style={{ flex: 1 }}>
                 
                </div>
              
              </div>







            </div>
          </div>

        </div>

      </div>
    </div>
   
     
  )
}

export default Tab1